<template>
  <div class="discuss_detail">
    <el-dialog
      title="讨论详情"
      :visible.sync="openDialog"
      width="50%"
      class="dialog_title"
      @close="closeDialog"
    >
      <section style="position: relative; margin-bottom: 50px">
        <el-row type="flex" style="">
          <el-col :span="1" class="mr-10">
            <div class="avatar-center">
              <el-avatar
                shape="square"
                size="medium"
                :src="imgSrc"
              ></el-avatar>
            </div>
          </el-col>
          <el-col :span="23">
            <p style="font-size: 16px; margin-bottom: 10px">讨论主题：</p>
            <section class="c-999 lh24 mb10">
              {{ detailsTitle.theme }}
            </section>
          </el-col>
        </el-row>
        <div style="position: absolute; right: 14px">
          {{ detailsTitle.create_time }}
        </div>
      </section>

      <section class="form-background">
        <el-row type="flex" class="conditions">
          <el-col :span="2">
            <div class="avatar-center pb10">
              <strong>发言({{ detailsList.length }})</strong>
            </div>
          </el-col>
        </el-row>
        <div
          class="remark-content bgcf2 mb10 pd-10 bdr4"
          v-for="(item, index) in detailsList"
          :key="index"
        >
          <el-row type="flex" class="row-bg mb-4">
            <el-col :span="1" class="mr-10">
              <div class="avatar-center">
                <el-avatar
                  shape="square"
                  size="medium"
                  :src="item.image"
                ></el-avatar>
              </div>
            </el-col>
            <el-col :span="23">
              <div class="flex_sb">
                <div>
                  <p style="font-size: 14px; margin-bottom: 10px">
                    {{ item.truename }}
                  </p>
                </div>
                <div class="mr10">
                  {{ parseTime(item.date, "{y}-{m}-{d} {h}:{i}") }}
                </div>
              </div>
              <section v-html="item.content">
                <!--{{}}-->
              </section>
            </el-col>
          </el-row>
        </div>
      </section>

      <div slot="footer" class="dialog-footer">
        <!--<el-button type="primary" @click="submitForm" size="small">确 定</el-button>-->
        <el-button @click="cancel" size="small">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { DiscussionDetail } from "@/api/tearcher";
export default {
  data() {
    return {
      openDialog: false,
      detailsList: [],
      detailsTitle: {},
      defalutImg:
        "https://dckj.ks3-cn-guangzhou.ksyun.com/ltedu3/20200318/d3904597-eff5-4048-8808-8183b2b64c7a.png",
    };
  },
  methods: {
    closeDialog() {},
    // 操作dialog
    operationDialog(row) {
      this.openDialog = true;
      DiscussionDetail({ id: row.id }).then((res) => {
        this.detailsList = res.data.detail;
        this.detailsTitle = res.data.title;
        this.detailsList.map((item) => {
        //   let answer = +item.image;
          if (item.image == 0 || !item.image) {
            // 如果answer为NaN则为true
            item.image = this.defalutImg
            // this.defalutImg = this.userInfo.image;
            // console.log(this.defalutImg, "this.defalutImg");
          }
        });
      });
    },
    // 取消按钮
    cancel() {
      this.openDialog = false;
    },
  },
  computed:{
      imgSrc(){
          return (this.detailsTitle.image == 0 || !this.detailsTitle.image) ? this.defalutImg : this.detailsTitle.image
      }
  },
  created(){
  }
};
</script>
 
<style lang = "less" scoped>
.discuss_detail {
}
</style>